<template>
  <div>
    <v-navigation-drawer
      clipped
      app
      :permanent="!isMobile"
      v-model="drawer"
      class="navigation-drawer"
    >
      <v-list nav dense>
        <v-list-item link to="/captures">
          <v-list-item-icon class="navigation-link-icon">
            <v-icon>$icons_product_payment_success</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="navigation-link-icon">
            <v-list-item-title>{{ $t("navigation.menu.captures") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="routePath.FAILED_CAPTURES">
          <v-list-item-icon class="navigation-link-icon">
            <v-icon>$icons_product_payment_failed</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="navigation-link-icon">
            <v-list-item-title>{{ $t("navigation.menu.failed") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/refunds">
          <v-list-item-icon class="navigation-link-icon">
            <v-icon>$icons_product_refund</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="navigation-link-icon">
            <v-list-item-title>{{ $t("navigation.menu.refunds") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/reporting/payouts">
          <v-list-item-icon class="navigation-link-icon">
            <v-icon>$icons_product_payouts</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="navigation-link-icon">
            <v-list-item-title>{{ $t("navigation.menu.payouts") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/disputes">
          <v-list-item-icon class="navigation-link-icon">
            <v-icon>$icons_product_business_scale</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="navigation-link-icon">
            <v-list-item-title>{{ $t("navigation.menu.disputes") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/users/" v-if="hasAccess('fleetAdmin')">
          <v-list-item-icon class="navigation-link-icon">
            <v-icon>$icons_product_worker</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t('navigation.menu.users')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/payment-onboarding" v-if="hasAccess('fleetAdmin')">
          <v-list-item-icon class="navigation-link-icon">
            <v-icon>$icons_product_onboarding</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("navigation.menu.paymentOnboarding") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/banking-onboarding" v-if="hasAccess('fleetAdmin')">
          <v-list-item-icon class="navigation-link-icon">
             <v-icon>$icons_product_bank</v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            <v-list-item-title>{{ $t("navigation.menu.bankingOnboarding") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/privacy-policy" v-if="hasAccess('fleetAdmin')">
          <v-list-item-icon class="navigation-link-icon">
             <v-icon>
               mdi-file-compare
             </v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            <v-list-item-title>{{ $t("navigation.menu.privacyPolicy") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/terms-and-conditions" v-if="hasAccess('fleetAdmin')">
          <v-list-item-icon class="navigation-link-icon">
            <v-icon>
              mdi-file-document
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            <v-list-item-title>{{ $t("navigation.menu.termsAndConditions") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/app-publish-key-settings" v-if="hasAccess('fleetAdmin')">
          <v-list-item-icon class="navigation-link-icon">
            <v-icon>
              mdi-key
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            <v-list-item-title>{{ $t("navigation.menu.appPublishKeySettings") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <user-profile-navigation :displayName="displayName" />
    </v-navigation-drawer>
    <v-app-bar clipped-left app class="header-bar" color="white">
      <v-icon @click.stop="drawer = !drawer" v-if="isMobile">mdi-menu</v-icon>
      <v-spacer v-if="isMobile"></v-spacer>
      <img :src="logoURL" class="nav-logo mr-4 align-center" large/>
      <v-toolbar-title class="align-center">
        <span class="title">Customer Console <sup>{{ appVersion }}</sup></span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <fleet-selector v-if="showFleetSelector"></fleet-selector>
    </v-app-bar>
  </div>
</template>

<script>
import { RoutePath } from '@/routing/routePath';
import { isMobile } from '../mixins/responsive.mixins';
import { bookingChannelComputed } from '../mixins/bookingChannel.mixins';
import UserProfileNavigation from './UserProfileNavigation.vue';
import FleetSelector from './FleetSelector.vue';
import { accesses } from '../mixins/authentication.mixins';

export default {
  mixins: [isMobile, bookingChannelComputed, accesses],
  components: { UserProfileNavigation, FleetSelector },
  props: {
    userRoles: {
      type: Array,
    },
    displayName: {
      type: String,
    },
  },
  data() {
    return {
      drawer: false,
      routePath: RoutePath,
      showStripeDialog: false,
    };
  },
  computed: {
    showFleetSelector() {
      return this.$route.meta.showFleetSelector;
    },
    appVersion() {
      return process.env.VUE_APP_VERSION;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list-item__title {
  text-align: left;
}
.navigation-drawer {
  .v-list {
    padding-left: 0px;
    padding-right: 0px;
    color: black;

  }

  .v-list-item__icon {
    padding-left: 7px;
    svg {
      color: black !important;
    }
  }
  .v-list-item::before {
    border-radius: 0;
  }
  .v-list-item:first-child {
    margin-top: 25px;
  }
}

.header-bar {
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.25);
}
</style>

<style lang="scss">
.header-bar {
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.25) !important;
}
.app-navigation {
  height: auto;
}
.v-navigation-drawer {
  width: 210px;
}
.nav-logo {
  height: 100%;
}
.navigation-link-title {
  text-align: left;
}
.nav-logo {
  height: 40px;
}
</style>
